import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncrease = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 17 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.0002 0H10.0002C9.6315 0 9.3335 0.298 9.3335 0.666667C9.3335 1.03533 9.6315 1.33333 10.0002 1.33333H13.7242L9.3495 5.708C8.9735 6.084 8.3615 6.084 7.98483 5.708L6.29217 4.01533C5.39617 3.11933 3.93817 3.11933 3.04217 4.01533L0.1955 6.862C-0.0651667 7.12267 -0.0651667 7.544 0.1955 7.80467C0.3255 7.93467 0.496167 8 0.666833 8C0.8375 8 1.00817 7.93467 1.13817 7.80467L3.98483 4.958C4.3495 4.59333 4.98483 4.59333 5.3495 4.958L7.04217 6.65067C7.93817 7.54667 9.39617 7.54667 10.2922 6.65067L14.6675 2.276V6C14.6675 6.36867 14.9655 6.66667 15.3342 6.66667C15.7028 6.66667 16.0008 6.36867 16.0008 6V2C16.0008 0.897333 15.1028 0 14.0002 0Z",
		fill: "currentColor"
	})
});
export default SvgIncrease;
